module.exports = __webpack_public_path__ + "img/1-3.bc7be3b7.svg";